// extracted by mini-css-extract-plugin
module.exports = {"note":"Note_note__-Zc-h","header":"Note_header__1NZOP","date":"Note_date__3UXpd","text":"Note_text__1y105"};